import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from '@lightspeed/flame/Button';
import { Divider } from '@lightspeed/flame/Divider';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import Select from '@lightspeed/cirrus-select';
import FormField from 'cirrus/FormField';

class DepositRefundSelectionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      selectedTerminal: props.lastUsedTerminal
        ? props.lastUsedTerminal.model.id
        : props.terminals[0].model.id,
      amount: props.amount,
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleRefundClicked = this.handleRefundClicked.bind(this);
    this.handleTerminalChange = this.handleTerminalChange.bind(this);
  }

  /**
   * Handles closing the modal.  Since we have closing animations, we need to make
   * sure we wait for that to finish before we unmount otherwise we'll get an
   * exception thrown by React.
   */
  // eslint-disable-next-line react/sort-comp
  handleCloseModal() {
    this.setState(
      {
        showModal: false,
      },
      () => {
        // In case the animation end was not triggered
        setTimeout(() => {
          this.props.onCancel();
        }, 250);
      }
    );
  }

  /**
   * Event handler for when the user clicks on the Refund button.
   */
  handleRefundClicked() {
    this.props.onRefund(this.state.selectedTerminal);
    this.handleCloseModal();
  }

  /**
   * Event handler for when the deposit amount changes.
   *
   */
  handleTerminalChange(event) {
    const { value } = event.currentTarget;

    const selectedTerminal = this.getDropdownData().find(terminal => terminal.value === value);
    this.setState({ selectedTerminal: selectedTerminal.value });
  }

  /**
   * Adapts the terminal data to the format expected by the Dropdown component.
   *
   * @returns {{value: string, label: string}[]}    The terminal data in the Dropdown component format
   */
  getDropdownData() {
    const { terminals } = this.props;

    return terminals.map(terminal => ({
      value: terminal.model.id,
      label: terminal.model.get('name'),
    }));
  }

  /**
   * Adapts the selected terminal data to the format expected by the Dropdown component.
   *
   * @returns {value: string, label: string}  The selected terminal data in the Dropdown component format
   */
  getSelectedTerminalData() {
    const terminalData = this.getDropdownData();

    return (
      // @TODO Kurt / Fred please fix this
      this.getDropdownData().find(
        // eslint-disable-next-line no-shadow
        terminalData => terminalData.value === this.state.selectedTerminal
      ) || terminalData[0] // if none is selected just selet the first one
    );
  }

  /**
   * The Line for the Transaction Amount to be Rendered if it exists
   *
   * @returns {node} The Rendered Line to be embedded into the AddDepositModal
   */
  getPaymentAmount() {
    return (
      <Fragment>
        <Divider className="cr-mv-4" />
        <label>Transaction Amount</label>
        <input
          className="inline-input display-input"
          disabled="disabled"
          value={this.state.amount}
        />
      </Fragment>
    );
  }

  /**
   * The React render method.
   *
   * @returns {node}  The rendered AddDepositModal
   */
  render() {
    const { showModal } = this.state;
    return (
      <Modal
        className="cirrus deposit-modal"
        isOpen={showModal}
        onRequestClose={this.handleCloseModal}
        shouldCloseOnOverlayClick={false}
      >
        <ModalHeader className="add-deposit-header" onCloseClicked={this.handleCloseModal}>
          Credit/Debit
        </ModalHeader>
        <ModalBody>
          <FormField label="Payment Terminal">
            <Select
              id="refund-terminal"
              value={this.getSelectedTerminalData().value}
              onChange={this.handleTerminalChange}
            >
              {this.getDropdownData().map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </FormField>
          {this.state.amount ? this.getPaymentAmount() : null}
        </ModalBody>
        <ModalFooter className="add-deposit-footer">
          <Group className="cr-justify-end">
            <Button id="cancel-deposit" onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button id="refund-deposit" variant="primary" fill onClick={this.handleRefundClicked}>
              Start Refund
            </Button>
          </Group>
        </ModalFooter>
      </Modal>
    );
  }
}

DepositRefundSelectionModal.propTypes = {
  onRefund: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  lastUsedTerminal: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  terminals: PropTypes.array.isRequired,
  amount: PropTypes.string,
};

DepositRefundSelectionModal.defaultProps = {
  lastUsedTerminal: null,
  amount: null,
};

export default DepositRefundSelectionModal;
